import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  HealthOrganizationCheckoutSummary,
  UserCheckout,
  UsersGroupedByCategory,
} from "src/app/core/model/v2/practice/RoleGroupedUser";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { Location } from "@angular/common";
import { EmployerService } from "src/app/core/services/v2/employer.service";
import { UserService } from "src/app/core/services/v2/user.service";
import { SharedDataService } from "src/app/core/services/v2/shared-emp-subscription.service";
import { CreditCardComponent } from "src/app/market-place/market-place-home/product-checkout/credit-card/credit-card.component";
import { MatDialog } from "@angular/material/dialog";
import { UtilsService } from "src/app/core/services/v2/utils.service";
import { AppyUser } from "src/app/core/model/v2/AppyUser";
import { PaymentProfile } from "src/app/core/models/UserPaymentProfile/userPaymentProfile";
import { PatientService } from "src/app/core/services/v2/patient.service";

@Component({
   selector: 'app-employee-active-program-checkout',
  templateUrl: './employee-active-program-checkout.component.html',
  styleUrls: ['./employee-active-program-checkout.component.scss'],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class EmployeeActiveProgramCheckoutComponent implements OnInit {
  roleGroupedUsers: UsersGroupedByCategory[];
  healthOrganizationCheckoutSummary: HealthOrganizationCheckoutSummary;
  errorMessage: string;
  changeCard: boolean = false;
  // subscriptionType: number;
  summaryAmount: number = 0;
 customerProfileId: string;
 tableData : any = [{
  planName : '',
  employeesCount: -Infinity,
  price:''
 }]
 
  // userAppy: AppyUser;
  creditCards: PaymentProfile[];
  columnsToDisplay = [
    "roleCategory",
    "numberOfPersons",
    "totalPendingOneTimeFee",
    "totalPendingMonthlyFee"
  ];
  activationType: string;
  selectedType: number = 0;

  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  displayedColumns = [
    "name",
    // "roleCategory",
    "pendingOneTimeFee",
    "monthlyFee",
  ];
  expandedElement: UserCheckout | null;
  subscriptionType: number | undefined;
  selectedPlan: any; // Holds the selected plan data
  planId: number;
  // subscriptionPlans = [
  //   {
  //     id: 1,
  //     name: "Health",
  //     price:'$7.90',
  //     features: [
  //       "Teladoc ($0 Visit Fee)",
  //       "Health Advocate Solutions",
  //       "NB Fitness",
  //       "NB Rx",
  //       "Lab Testing",
  //       "NB Deals",
  //       "NB Travel",
  //       "NB Pet Rx"
  //     ]
  //   },
  //   {
  //     id: 2,
  //     name: "Health Plus",
  //     price:'$19.98',
    
  //     features: [
  //       "Teladoc ($0 Visit Fee)",
  //       "Health Advocate Solutions",
  //       "NB Fitness",
  //       "NB Rx",
  //       "Manifest Rx",
  //       "Lab Testing",
  //       "NB Deals",
  //       "NB Travel",
  //       "NB Pet Rx",
  //     ]
  //   },
  //   {
  //     id: 3,
  //     name: "Mental Health",
  //     price:'$10.15',

  //     features: [
  //       "Teladoc Mental Health ($0 Visit Fee)",
  //       "Health Advocate Solutions",
  //       "NB Fitness",
  //       "NB Rx",
  //       "Lab Testing",
  //       "NB Deals",
  //       "NB Travel",
  //       "NB Pet Rx",
  //     ]
  //   },
  //   {
  //     id: 4,
  //     name: "Premium Health",
  //     price:'$36.35',

  //     features: [
  //       "Teladoc ($0 Visit Fee)",
  //       "Teladoc Mental Health ($0 Visit Fee)",
  //      " Manifest Rx",
  //       "Health Advocate Solutions",
  //       "NB Fitness",
  //       "LifeLock Essential Individual",
  //       "NB Pet Telehealth",
  //       "NB Rx",
  //       "Lab Testing",
  //       "NB Deals",
  //       "NB Travel",
  //       "NB Pet Rx",
  //     ]
  //   },
  //   // Add more plans as needed
  // ];
  subscriptionTypes:any = [];

  planDetails: any[] = []; // Holds the data to be displayed in the table
  // userId: number;
  employerId: number;
  user: any = [];
  // checkoutInfo: any;
  checkoutInfo: any = {
    individualDueAmount: 0,
    salesTaxAmount: 0,
    totalPlanAmount: 0,
    totalPlanAmountWithTax: 0,
    employeesCount: 0,
  };
  taxRate: number = 8.25 / 100; // Tax rate: 8.25%
  selectedEmployeeIds: number[] = [];
  noActivePlan : boolean = false;
  activePlanName: any;
  activePlanNames: any;
  activePlanDetails: any;
  activeSubscriptionId: any;

  constructor(
    private router: Router,
    private practiceService: PracticeService,
    private loaderService: WindowLoaderService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private employerService: EmployerService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    public dialog: MatDialog,
    private utils: UtilsService,
    private patientService: PatientService,
    
    
  ) {}

  ngOnInit() {
    this.selectedEmployeeIds = history.state.selectedEmployeeIds || [];
    this.activePlanDetails = history.state.planDetails;
    this.activeSubscriptionId   = history.state.activeSubscriptionId
    console.log("✅ Received Employee IDs:", this.selectedEmployeeIds);
    console.log("🔢 Total Employee Count:", this.selectedEmployeeIds.length);
    console.log("activeProgramNameDetails:", this.activePlanDetails);


 this.tableData[0].employeesCount = this.selectedEmployeeIds.length;
    
this.getUserDetails();

this.GetPaymentInformation();

    this.calculateSummaryAmount();

}
calculateSummaryAmount(): void {
  if (this.planDetails && this.planDetails.length > 0) {
    this.summaryAmount = this.planDetails.reduce((total, element) => {
      return total + element.price * element.employeesCount;
    }, 0);
  }
}

updateTableDataBasedOnSelectedPlan() {
  if (this.selectedPlan) {
    // Assuming you want to display plan details like features
    // this.planDetails = this.selectedPlan.features.map(feature => ({
    //   planName: this.selectedPlan.name,  // Add plan name here
    //   feature: feature,  // Add feature details
    //   fee: '$0',          // Example fee (you can adjust based on the plan details)
    //   description: 'Feature description'  // Add any other necessary details for the feature
    // }));
    this.planDetails = [{
      planName: this.selectedPlan.name,  // Plan name
      // price: this.selectedPlan.price,  // Example fee, adjust based on your requirements
      price: parseFloat(this.selectedPlan.price.replace('$', '')),  // Convert price to number by removing the '$' sign
     description: 'A comprehensive plan with various health benefits'  // Example description
    }];

    console.log('Plan Details:', this.planDetails);
  }
}
get totalAmount(): number {
  return this.planDetails.reduce((total, element) => total + (element.price * element.employeesCount), 0);
}
get taxAmount(): number {
  return this.totalAmount * this.taxRate; // Calculate tax
}

get totalWithTax(): number {
  return this.totalAmount + this.taxAmount; // Total amount including tax
}

getUserDetails() {
  this.loaderService.show();
  this.userService.getUserDetails().subscribe(
    (userDetails) => {
      this.user = userDetails;
      console.log("user", this.user);
      // this.userId = userDetails.id;
      this.employerId = userDetails.employerId
      // console.log("This is userId: ", this.userId);
      console.log("This is employerId: ", this.employerId);
      this.getPatientSubscriptionTypes(()=>{this.getEmployerHealthSubscriptionByEmployerId123456();})

    },
    (error) => { console.error(error); }
  );
}



getEmployerHealthSubscriptionByEmployerId123456() {
  this.loaderService.show();
  this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
    (res) => {
      if (res && res.result && res.result.length > 0) {
        const subscription = res.result[0];

        // Check if subscriptionTypeId is 0 or active is null
        if (subscription.subscriptionTypeId === 0 || subscription.active === null) {
          this.noActivePlan = true;
          this.loaderService.hide();
          return;
        }

        console.log("Subscription Details:", subscription);

        // Null check for subscriptionType
        this.activePlanName = (subscription.subscriptionType && subscription.subscriptionType.name)
  ? subscription.subscriptionType.name
  : "Unknown Plan";


        this.tableData[0].planName = this.activePlanDetails;
        this.selectedType = subscription.subscriptionTypeId;
        this.activationType = subscription.active ? "Activate" : "Deactivate";

        // Update subscription plan's active status
        const selectedPlan = this.subscriptionTypes.find(plan => plan.id === subscription.subscriptionTypeId);
        this.subscriptionTypes = this.subscriptionTypes.filter(x => x.id !== subscription.subscriptionTypeId);
        this.selectedPlan = selectedPlan;

        this.loaderService.hide();
        this.getEmpCheckOutInfomation(); // uses updated this.selectedType
      } else {
        this.noActivePlan = true;
        this.loaderService.hide();
      }
    },
    (error) => {
      console.error("Error fetching subscription details:", error);
      this.noActivePlan = true;
      this.loaderService.hide();
    }
  );
}



// Function to update selected plan when user selects from dropdown
onPlanChange(element: any, selectedPlan: any) {
  element.selectedPlan = selectedPlan;
}

getPatientSubscriptionTypes(cb: () => void) {
  this.loaderService.show();
  this.patientService.getPatientSubscriptionTypes().subscribe(
    (res) => {
      if (res && res.result && Array.isArray(res.result)) {
        this.subscriptionTypes = res.result; 
        console.log("Subscription Types:", this.subscriptionTypes);
        
        if (typeof cb === "function") {
          cb(); 
        }
      } else {
        console.warn("Invalid response structure:", res);
        this.subscriptionTypes = []; 
      }

      this.loaderService.hide();
    },
    (error) => {
      console.error("Error fetching subscription types:", error);
      this.subscriptionTypes = []; 
      this.loaderService.hide();
    }
  );
}
getEmpCheckOutInfomation() {
  this.employerService.getEmployerSubscriptionCheckOutInfomation(
    this.user.employerId,
  ).subscribe(
    (checkoutSummary) => {
      console.log("checkoutSummary", checkoutSummary.result);
      if (checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.isSuccess) {
        console.log("checkoutSummary", checkoutSummary.result);
        this.checkoutInfo = checkoutSummary.result;
        // Update tableData with the fetched checkout summary values
        this.tableData = [{
          planName: this.activePlanDetails,
          individualDueAmount: checkoutSummary.result.individualDueAmount,
          salesTaxAmount: checkoutSummary.result.salesTaxAmount,
          totalPlanAmount: checkoutSummary.result.totalPlanAmount,
          totalPlanAmountWithTax: checkoutSummary.result.totalPlanAmountWithTax,
          employeesCount: checkoutSummary.result.employeesCount
        }];
      } else {
        // Handle API failure
        console.warn("API request failed:", checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.message || "Unknown error occurred.");
        // this.utils.showMessageSnackBar(checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.message || "Failed to fetch checkout information.", true);
        const errorMessage = checkoutSummary && checkoutSummary.resultStatus && checkoutSummary.resultStatus.errorMessages
        ? checkoutSummary.resultStatus.errorMessages.join(", ")
        : "Failed to fetch subscription details.";
      
      this.utils.showMessageSnackBar(errorMessage, true);
      }
  
    },
    (error) => {
      console.error("Error fetching checkout information:", error);
    }
  );
}

goBack() {
    this.location.back();
  }

  completeCheckout() {
    this.pay();
  }

  reload() {
    // this.LoadCheckoutSummary();
  }

  addChangeCard() {
    this.changeCard = !this.changeCard;
    console.log("add change card");
  }

  updateEmployerHealthSubscription() {

  
    this.loaderService.show();
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedPlan.id && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
 
      this.employerService
        .updateEmployerHealthSubscription(
          this.user.employerId,
          this.selectedPlan.id,
          this.activationType,
        )
        .subscribe(
          (result) => {
            console.log("result update employer subscription", result);
            this.subscriptionType = this.selectedPlan.id;
            this.activationType = this.activationType;
            // this.getUserDetails();
            this.utils.showMessageSnackBar('program subscribed successfully.');

            this.loaderService.hide();
            document.getElementById("clsModal").click();
          },
          (error) => {
            console.error(error);
            this.loaderService.hide();
          }
        );
    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
    }
  }

  pay() {
    this.loaderService.show();
    this.userService
      .chargeUserSubscriptionFee(this.selectedPlan.id)
      .subscribe(
        (res) => {
          console.log("payment response",res);
          if (res.resultStatus.isSuccess) {
            this.errorMessage = "";
            this.updateEmployerHealthSubscription();
             this.router.navigate(["/employer/subscription-method"]);
          } else {
            this.errorMessage = res.resultStatus.message;
          }
          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
  }
  GetPaymentInformation() {

      this.loaderService.blockWithLoader(this.userService.GetPaymentInformation("")).subscribe(data => {
        console.log("Payment Information", data);
        console.log("Credit Cards", data.profile.paymentProfiles);
        this.creditCards = data.profile.paymentProfiles;
        this.customerProfileId = data.profile.customerProfileId
      });
    
  }

    addCreditCard(): void {
      const dialogRef = this.dialog.open(CreditCardComponent, {
        // height: '45%',
        width: '748px',
        disableClose: true,
        data: this.customerProfileId ? this.customerProfileId : null
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res && res.data && res.data.resultStatus) {
          if (res.data.resultStatus.isSuccess) {
            this.utils.showMessageSnackBar('Credit card saved successfully.');
          }
          else {
            this.utils.showMessageSnackBar(res.data.resultStatus.message, true);
          }
        }
        this.GetPaymentInformation();
      });
    }
    get hasEmployees(): boolean {
      return this.tableData && this.tableData.some(plan => plan.employeesCount > 0);
    }
    navigateToEmployeeSelection() {
      console.log("Navigating with:",);
    
      this.router.navigate(["/employer/employees"]);
    } 
}
